import { render, staticRenderFns } from "./GoogleAdPreviewV2.vue?vue&type=template&id=32a24118&scoped=true&"
import script from "./GoogleAdPreviewV2.vue?vue&type=script&lang=js&"
export * from "./GoogleAdPreviewV2.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAdPreviewV2.vue?vue&type=style&index=0&id=32a24118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a24118",
  null
  
)

export default component.exports